<template>
    <div>
        <button
            v-if="!showPopup"
            class="fixed z-50 p-3 text-white rounded-full shadow-lg bg-primary cookie-icon bottom-4 right-4"
            @click="openCookie"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 8c-1.1 0-2 .9-2 2m0 0c0 1.1.9 2 2 2m0-2h.01M17.656 9.172c.59.59.59 1.536 0 2.121m-4.243-2.12a1.5 1.5 0 100 2.121M8 15h.01m0 0a1.5 1.5 0 102.121 0m-2.121 0c-.59-.59-.59-1.536 0-2.121M15 8h-.01M9.172 17.657c-.59-.59-.59-1.536 0-2.121M19 12c0 3.866-3.134 7-7 7s-7-3.134-7-7 3.134-7 7-7 7 3.134 7 7z"
                />
            </svg>
        </button>
        <div class="cookie-pop-up" v-if="showPopup">
            <div class="cookie-content">
                <div
                    class="cookie-body"
                    v-html="trans.get('cookie.cookie_body')"
                ></div>
                <div class="cookie-footer-custom">
                    <button
                        type="button"
                        class="hover:text-primary"
                        @click="toggleModal(true)"
                        v-text="trans.get('cookie.settings')"
                    ></button>
                    <button
                        type="button"
                        class="px-4 py-2 ml-3 text-white border rounded-2xl bg-primary border-primary hover:bg-white hover:text-primary"
                        @click="acceptRequired"
                        v-text="trans.get('cookie.accept_only_required')"
                    ></button>
                    <button
                        type="button"
                        class="px-4 py-2 ml-3 text-white border rounded-2xl bg-primary border-primary hover:bg-white hover:text-primary"
                        @click="acceptAll"
                        v-text="trans.get('cookie.accept_all')"
                    ></button>
                    <button
                        type="button"
                        class="px-4 py-2 ml-3 text-white border rounded-2xl bg-primary border-primary hover:bg-white hover:text-primary"
                        @click="cancelAll"
                        v-text="trans.get('cookie.cancel_all')"
                    ></button>
                </div>
            </div>

            <div class="cookie-modal" v-show="showModal">
                <div class="cookie-modal-content">
                    <div class="cookie-modal-header">
                        <h4
                            class="text-xl font-semibold"
                            v-text="trans.get('cookie.modal.title')"
                        ></h4>
                        <button @click="toggleModal(false)" class="text-xl">
                            &times;
                        </button>
                    </div>
                    <div class="cookie-modal-body">
                        <div v-html="trans.get('cookie.cookie_body')"></div>
                        <div class="mt-4"></div>

                        <div class="mt-4 cookie-accordion">
                            <button
                                type="button"
                                :class="[
                                    'cookie-accordion-header',
                                    {
                                        _open: accordion.required,
                                    },
                                ]"
                                @click="toggleAccordion('required')"
                            >
                                <span
                                    v-text="
                                        trans.get(
                                            'cookie.modal.required_cookies'
                                        )
                                    "
                                ></span>

                                <svg
                                    version="1.2"
                                    preserveAspectRatio="none"
                                    viewBox="0 0 24 24"
                                    class="icon-wedge-svg"
                                    data-id="e9b3c566e8c14cfea38af128759b91a3"
                                    style="
                                        opacity: 1;
                                        mix-blend-mode: normal;
                                        fill: rgb(51, 51, 51);
                                        width: 32px;
                                        height: 32px;
                                    "
                                >
                                    <path
                                        xmlns:default="http://www.w3.org/2000/svg"
                                        id="angle-down"
                                        d="M17.2,9.84c0-0.09-0.04-0.18-0.1-0.24l-0.52-0.52c-0.13-0.13-0.33-0.14-0.47-0.01c0,0-0.01,0.01-0.01,0.01  l-4.1,4.1l-4.09-4.1C7.78,8.94,7.57,8.94,7.44,9.06c0,0-0.01,0.01-0.01,0.01L6.91,9.6c-0.13,0.13-0.14,0.33-0.01,0.47  c0,0,0.01,0.01,0.01,0.01l4.85,4.85c0.13,0.13,0.33,0.14,0.47,0.01c0,0,0.01-0.01,0.01-0.01l4.85-4.85c0.06-0.06,0.1-0.15,0.1-0.24  l0,0H17.2z"
                                        style="fill: rgb(51, 51, 51)"
                                    ></path>
                                </svg>
                            </button>
                            <div
                                :class="[
                                    'cookie-accordion-content',
                                    {
                                        '_open pb-6': accordion.required,
                                    },
                                ]"
                            >
                                <div
                                    class="cookie-accordion-content-body"
                                    v-html="
                                        trans.get(
                                            'cookie.modal.required_cookies_body'
                                        )
                                    "
                                ></div>
                                <table
                                    class="mx-auto my-6 border-collapse cookie-table"
                                >
                                    <thead>
                                        <tr>
                                            <th class="p-2 text-left border">
                                                {{ trans.get("cookie.name") }}
                                            </th>
                                            <th class="p-2 text-left border">
                                                {{
                                                    trans.get("cookie.duration")
                                                }}
                                            </th>
                                            <th class="p-2 text-left border">
                                                {{ trans.get("cookie.page") }}
                                            </th>
                                            <th class="p-2 text-left border">
                                                {{
                                                    trans.get(
                                                        "cookie.description"
                                                    )
                                                }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="p-2 border">
                                                hrvatske_autocest_session
                                            </td>
                                            <td class="p-2 border">
                                                2
                                                {{ trans.get("cookie.hours") }}
                                            </td>
                                            <td class="p-2 border">
                                                Kolačić prve strane
                                            </td>
                                            <td class="p-2 border">
                                                {{
                                                    trans.get(
                                                        "cookie.hrvatske_autocest_session_description"
                                                    )
                                                }}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="p-2 border">
                                                XSRF-TOKEN
                                            </td>
                                            <td class="p-2 border">
                                                2
                                                {{ trans.get("cookie.hours") }}
                                            </td>
                                            <td class="p-2 border">
                                                Kolačić prve strane
                                            </td>
                                            <td class="p-2 border">
                                                {{
                                                    trans.get(
                                                        "cookie.XSRF_TOKEN_description"
                                                    )
                                                }}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="p-2 border">
                                                Cookie_consent
                                            </td>
                                            <td class="p-2 border">
                                                1 {{ trans.get("cookie.year") }}
                                            </td>
                                            <td class="p-2 border">
                                                Kolačić prve strane
                                            </td>
                                            <td class="p-2 border">
                                                {{
                                                    trans.get(
                                                        "cookie.cookie_consent_description"
                                                    )
                                                }}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="p-2 border">locale</td>
                                            <td class="p-2 border">
                                                1 {{ trans.get("cookie.year") }}
                                            </td>
                                            <td class="p-2 border">
                                                Kolačić prve strane
                                            </td>
                                            <td class="p-2 border">
                                                {{
                                                    trans.get(
                                                        "cookie.locale_description"
                                                    )
                                                }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- <div class="cookie-accordion">
                            <button
                                type="button"
                                :class="['cookie-accordion-header', {
                                    '_open': accordion.functional
                                }]"
                                @click="toggleAccordion('functional')"
                            >
                                <span class="flex items-center">
                                    <span :class="{
                                        'w-2 h-2 bg-green-500 rounded-full mr-2 block': settings.functional.enabled,
                                        'w-2 h-2 bg-red-500 rounded-full mr-2 block': !settings.functional.enabled,
                                    }"></span>
                                    <span v-text="trans.get('cookie.modal.functional_cookies')"></span>
                                </span>
    
                                <svg version="1.2" preserveAspectRatio="none" viewBox="0 0 24 24" class="icon-wedge-svg" data-id="e9b3c566e8c14cfea38af128759b91a3" style="opacity: 1; mix-blend-mode: normal; fill: rgb(51, 51, 51); width: 32px; height: 32px;"><path xmlns:default="http://www.w3.org/2000/svg" id="angle-down" d="M17.2,9.84c0-0.09-0.04-0.18-0.1-0.24l-0.52-0.52c-0.13-0.13-0.33-0.14-0.47-0.01c0,0-0.01,0.01-0.01,0.01  l-4.1,4.1l-4.09-4.1C7.78,8.94,7.57,8.94,7.44,9.06c0,0-0.01,0.01-0.01,0.01L6.91,9.6c-0.13,0.13-0.14,0.33-0.01,0.47  c0,0,0.01,0.01,0.01,0.01l4.85,4.85c0.13,0.13,0.33,0.14,0.47,0.01c0,0,0.01-0.01,0.01-0.01l4.85-4.85c0.06-0.06,0.1-0.15,0.1-0.24  l0,0H17.2z" style="fill: rgb(51, 51, 51);"></path></svg>
                            </button>
    
                            <div :class="['cookie-accordion-content', {
                                '_open pb-6': accordion.functional
                            }]">
                                <div class="cookie-accordion-content-body">
                                    <p v-text="trans.get('cookie.modal.functional_cookies_body_1')"></p>
                                  <table class="mx-auto my-6 border-collapse cookie-table">
                                    <thead>
                                    <tr>
                                      <th class="p-2 text-left border">{{ trans.get('cookie.name') }}</th>
                                      <th class="p-2 text-left border">{{ trans.get('cookie.duration') }}</th>
                                      <th class="p-2 text-left border">{{ trans.get('cookie.page') }}</th>
                                      <th class="p-2 text-left border">{{ trans.get('cookie.description') }}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
    
                                      <tr>
                                        <td class="p-2 border">accessibility_settings</td>
                                        <td class="p-2 border">30 {{ trans.get('cookie.days') }}</td>
                                        <td class="p-2 border">Kolačić prve strane</td>
                                        <td class="p-2 border">
                                          {{ trans.get('cookie.accessibility_settings_description') }}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
    
                                  <div class="flex w-full mt-2">
                                        <div class="w-1/3">
                                            <div class="switch">
                                                <input id="functional" type="checkbox" v-model="settings.functional.enabled" />
                                                <label for="functional" class="label">
                                                    {{ trans.get('cookie.no') }}
                                                    <span class="_switch-control"></span>
                                                    {{ trans.get('cookie.yes') }}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="w-2/3" v-html="trans.get('cookie.modal.functional_cookies_body_2')"></div>
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <div class="cookie-accordion">
                            <button
                                type="button"
                                :class="[
                                    'cookie-accordion-header',
                                    {
                                        _open: accordion.analytics,
                                    },
                                ]"
                                @click="toggleAccordion('analytics')"
                            >
                                <span class="flex items-center">
                                    <span
                                        :class="{
                                            'w-2 h-2 bg-green-500 rounded-full mr-2 block':
                                                settings.analytics.enabled,
                                            'w-2 h-2 bg-red-500 rounded-full mr-2 block':
                                                !settings.analytics.enabled,
                                        }"
                                    ></span>
                                    <span
                                        v-text="
                                            trans.get(
                                                'cookie.modal.analytics_cookies'
                                            )
                                        "
                                    ></span>
                                </span>

                                <svg
                                    version="1.2"
                                    preserveAspectRatio="none"
                                    viewBox="0 0 24 24"
                                    class="icon-wedge-svg"
                                    data-id="e9b3c566e8c14cfea38af128759b91a3"
                                    style="
                                        opacity: 1;
                                        mix-blend-mode: normal;
                                        fill: rgb(51, 51, 51);
                                        width: 32px;
                                        height: 32px;
                                    "
                                >
                                    <path
                                        xmlns:default="http://www.w3.org/2000/svg"
                                        id="angle-down"
                                        d="M17.2,9.84c0-0.09-0.04-0.18-0.1-0.24l-0.52-0.52c-0.13-0.13-0.33-0.14-0.47-0.01c0,0-0.01,0.01-0.01,0.01  l-4.1,4.1l-4.09-4.1C7.78,8.94,7.57,8.94,7.44,9.06c0,0-0.01,0.01-0.01,0.01L6.91,9.6c-0.13,0.13-0.14,0.33-0.01,0.47  c0,0,0.01,0.01,0.01,0.01l4.85,4.85c0.13,0.13,0.33,0.14,0.47,0.01c0,0,0.01-0.01,0.01-0.01l4.85-4.85c0.06-0.06,0.1-0.15,0.1-0.24  l0,0H17.2z"
                                        style="fill: rgb(51, 51, 51)"
                                    ></path>
                                </svg>
                            </button>

                            <div
                                :class="[
                                    'cookie-accordion-content',
                                    {
                                        '_open pb-6': accordion.analytics,
                                    },
                                ]"
                            >
                                <div class="cookie-accordion-content-body">
                                    <p
                                        v-text="
                                            trans.get(
                                                'cookie.modal.analytics_cookies_body_1'
                                            )
                                        "
                                    ></p>

                                    <table
                                        class="mx-auto my-6 border-collapse cookie-table"
                                    >
                                        <thead>
                                            <tr>
                                                <th
                                                    class="p-2 text-left border"
                                                >
                                                    {{
                                                        trans.get("cookie.name")
                                                    }}
                                                </th>
                                                <th
                                                    class="p-2 text-left border"
                                                >
                                                    {{
                                                        trans.get(
                                                            "cookie.duration"
                                                        )
                                                    }}
                                                </th>
                                                <th
                                                    class="p-2 text-left border"
                                                >
                                                    {{
                                                        trans.get("cookie.page")
                                                    }}
                                                </th>

                                                <th
                                                    class="p-2 text-left border"
                                                >
                                                    {{
                                                        trans.get(
                                                            "cookie.description"
                                                        )
                                                    }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td class="p-2 border">_ga</td>
                                                <td class="p-2 border">
                                                    2
                                                    {{
                                                        trans.get(
                                                            "cookie.years"
                                                        )
                                                    }}
                                                </td>
                                                <td class="p-2 border">
                                                    Google
                                                </td>
                                                <td class="p-2 border">
                                                    {{
                                                        trans.get(
                                                            "cookie.ga_description"
                                                        )
                                                    }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="p-2 border">
                                                    _ga_&lt;container-id&gt;
                                                </td>
                                                <td class="p-2 border">
                                                    2
                                                    {{
                                                        trans.get(
                                                            "cookie.years"
                                                        )
                                                    }}
                                                </td>
                                                <td class="p-2 border">
                                                    Google
                                                </td>
                                                <td class="p-2 border">
                                                    {{
                                                        trans.get(
                                                            "cookie.session_persist_description"
                                                        )
                                                    }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="p-2 border">_gid</td>
                                                <td class="p-2 border">
                                                    24
                                                    {{
                                                        trans.get(
                                                            "cookie.hours"
                                                        )
                                                    }}
                                                </td>
                                                <td class="p-2 border">
                                                    Google
                                                </td>
                                                <td class="p-2 border">
                                                    {{
                                                        trans.get(
                                                            "cookie.gid_description"
                                                        )
                                                    }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="p-2 border">
                                                    _gat_gtag_&lt;container-id&gt;
                                                </td>
                                                <td class="p-2 border">
                                                    1
                                                    {{
                                                        trans.get(
                                                            "cookie.minute"
                                                        )
                                                    }}
                                                </td>
                                                <td class="p-2 border">
                                                    Google
                                                </td>
                                                <td class="p-2 border">
                                                    {{
                                                        trans.get(
                                                            "cookie.limit_service_description"
                                                        )
                                                    }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="p-2 border">
                                                    _gat_UA
                                                </td>
                                                <td class="p-2 border">
                                                    10
                                                    {{
                                                        trans.get(
                                                            "cookie.minute"
                                                        )
                                                    }}
                                                </td>
                                                <td class="p-2 border">
                                                    Google
                                                </td>
                                                <td class="p-2 border">
                                                    {{
                                                        trans.get(
                                                            "cookie.limit_data_collection_description"
                                                        )
                                                    }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div class="flex w-full mt-2">
                                        <div class="w-1/3">
                                            <div class="switch">
                                                <input
                                                    id="analytics"
                                                    type="checkbox"
                                                    v-model="
                                                        settings.analytics
                                                            .enabled
                                                    "
                                                />
                                                <label
                                                    for="analytics"
                                                    class="label"
                                                >
                                                    {{ trans.get("cookie.no") }}
                                                    <span
                                                        class="_switch-control"
                                                    ></span>
                                                    {{
                                                        trans.get("cookie.yes")
                                                    }}
                                                </label>
                                            </div>
                                        </div>
                                        <div
                                            class="w-2/3"
                                            v-html="
                                                trans.get(
                                                    'cookie.modal.analytics_cookies_body_2'
                                                )
                                            "
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="cookie-modal-footer">
                        <button
                            type="button"
                            class="px-4 py-2 mr-3 text-white border rounded-2xl bg-primary border-primary hover:bg-white hover:text-primary"
                            @click="acceptCurrent"
                            v-text="trans.get('cookie.save_settings')"
                        ></button>
                        <button
                            type="button"
                            class="px-4 py-2 mr-3 text-white border rounded-2xl bg-primary border-primary hover:bg-white hover:text-primary"
                            @click="acceptAll"
                            v-text="trans.get('cookie.accept_all')"
                        ></button>
                        <button
                            type="button"
                            class="px-4 py-2 text-white border rounded-2xl bg-primary border-primary hover:bg-white hover:text-primary"
                            @click="cancelAll"
                            v-text="trans.get('cookie.cancel_all')"
                        ></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CookiePopUp",

    props: {
        accepted: {
            required: true,
        },
    },

    data() {
        return {
            showPopup: false,
            showModal: false,
            settings: {
                required: {
                    enabled: true,
                },
                functional: {
                    enabled: true,
                },
                analytics: {
                    enabled: true,
                },
            },
            accordion: {
                required: true,
                functional: false,
                analytics: false,
            },
        };
    },

    created() {
        if (this.accepted) {
            return;
        }

        this.showPopup = true;
    },

    methods: {
        toggleModal(showModal) {
            this.showModal = showModal;
        },

        toggleAccordion(key) {
            this.accordion[key] = !this.accordion[key];
        },

        acceptCurrent() {
            this.setCookie("cookie_consent", JSON.stringify(this.settings));

            this.showPopup = false;
        },

        acceptRequired() {
            this.settings.required.enabled = true;
            this.settings.functional.enabled = false;
            this.settings.analytics.enabled = false;

            this.setCookie("cookie_consent", JSON.stringify(this.settings));

            this.showPopup = false;
        },

        acceptAll() {
            this.settings.required.enabled = true;
            this.settings.functional.enabled = true;
            this.settings.analytics.enabled = true;

            this.setCookie("cookie_consent", JSON.stringify(this.settings));

            this.showPopup = false;
        },

        cancelAll() {
            this.settings.required.enabled = false;
            this.settings.functional.enabled = false;
            this.settings.analytics.enabled = false;

            this.setCookie("cookie_consent", JSON.stringify(this.settings));

            this.showPopup = false;
        },

        openCookie() {
            document.cookie =
                "cookie_consent=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            this.showPopup = true;
        },

        setCookie(name, value) {
            var d = new Date();
            var durationDays = 365;

            d.setTime(d.getTime() + durationDays * 24 * 60 * 60 * 1000);

            var expires = "expires=" + d.toUTCString();

            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        },
    },
};
</script>
